// Core
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../../Middleware/axiosConfig";

// Utils
import { notifyError } from "Services/Utils/toastNotification";

// API End Points
import { API_END_POINTS } from "Middleware/apiEndpoints";

// API calls
//Pre assessent category list request
export const preAsessmentCategoryListRequest_USER = createAsyncThunk(
  "preAsessmentCategoryListRequest_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.preAsessmentCategoryListRequest_USER}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const preAssessmentViewAssessment = createAsyncThunk(
  "preAssessmentViewAssessment",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAssessmentAnswer_USER}?assessment_id=${data?.assessmentId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Pre assessent sub category list request
export const preAsessmentSubCategoryListRequest_USER = createAsyncThunk(
  "preAsessmentSubCategoryListRequest_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.preAsessmentSubCategoryListRequest_USER}/${data?.id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Pre assessent question request
export const preAsessmentQuestionRequest_USER = createAsyncThunk(
  "preAsessmentQuestionRequest_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.preAsessmentQuestionRequest_USER}${data?.categoryId}category_id=${data?.categoryId}&subCategory_id=${data?.subCategoryId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

// Async Thunk for getting the assessment report
export const getAssessmentReport = createAsyncThunk(
  "getAssessmentReport",
  async (data) => {
    const response = await APIKit().get(
      `${API_END_POINTS.getAssessmentReport}/${data.reportId}` // Use reportId
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Assessment subcategory details request
export const getAssessmentSubCategoryDetails_USER = createAsyncThunk(
  "getAssessmentSubCategoryDetails_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAssessmentSubCategoryDetails_USER}${data?.reportId}?category_id=${data?.subCategoryId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Pre assessent options of question request
export const preAsessmentOptionsOfQuestionRequest_USER = createAsyncThunk(
  "preAsessmentOptionsOfQuestionRequest_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.preAsessmentOptionsOfQuestionRequest_USER}${data?.questionId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

// Preasessment Pending API
export const getPastAssessment_USER = createAsyncThunk(
  "getPastAssessment_USER",
  async (data) => {
    // The FCM token
    const fcmToken = localStorage.getItem("fcmToken");

    // Define custom headers for this request only
    const customHeaders = {
      fcm_token: fcmToken,
    };
    // api hit
    const response = await APIKit(false, customHeaders).get(
      `${API_END_POINTS.getPastAssessment_USER}`
    );

    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getPendingtAssessment_USER = createAsyncThunk(
  "getPendingAssessment_USER",
  async (data) => {
    // The FCM token
    const fcmToken = localStorage.getItem("fcmToken");

    // Define custom headers for this request only
    const customHeaders = {
      fcm_token: fcmToken || "",
    };
    // api hit
    const response = await APIKit(false, customHeaders).get(
      `${API_END_POINTS.getPendingAssessment_USER}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getLatestAssessment_USER = createAsyncThunk(
  "getLatestAssessment_USER",
  async (data) => {
    const response = await APIKit().get(
      `${API_END_POINTS.getLatestAssessment_USER}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getAllSubModuleQuestions_USER = createAsyncThunk(
  "getAllQuestions_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAllQuestions_USER}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getPreassessmentRecommendation_USER = createAsyncThunk(
  "getPreassessmentRecommendation_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getPreassessmentRecommendation_USER}/${data.assessment_id}/${data.category_id}/${data.user_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
    }
    return response?.data;
  }
);

export const markRecommendationAsRead = createAsyncThunk(
  "markRecommendationAsRead",
  async ({ data, callBack, errorCallback }, { rejectWithValue }) => {
    try {
      const response = await APIKit().put(
        `${API_END_POINTS.markRecommendationAsRead}?assessment_id=${data?.assessment_id}&sub_category_id=${data?.sub_category_id}`
      );

      if (response?.status === 200 || response?.status === 201) {
        callBack?.(response);
        return response.data;
      } else {
        notifyError(response?.data?.message);
        errorCallback?.();
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      notifyError(error?.response?.data?.message || "Something went wrong");
      errorCallback?.();
      return rejectWithValue(error);
    }
  }
);

export const getRecommendationPercentageCompleted = createAsyncThunk(
  "getRecommendationPercentageCompleted",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getRecommendationPercentageCompleted}?assessment_id=${data?.assessment_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getAssessmentAnswer_USER = createAsyncThunk(
  "getAssessmentAnswer_USER",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.getAssessmentAnswer_USER}`,
      data?.data
    );
    if (response?.status === 201) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getPreviousAnswerData = createAsyncThunk(
  "getAssessmentAnswer_USER",
  async (data) => {
    const response = await APIKit().get(
      `${API_END_POINTS.getAssessmentAnswer_USER}?assessment_id=${data?.assessment_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getRecommendation_USER = createAsyncThunk(
  "getRecommendation_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getRecommendation_USER}/${data?.categoryId}/${data?.userId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      if (response?.status === !404) {
        notifyError(response?.data?.message);
      }
    }
    return response?.data;
  }
);

export const getAssessmentJourney = createAsyncThunk(
  "getAssessmentJourney",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAssessmentJourney}/${data?.assessmentId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      if (response?.status === !404) {
        notifyError(response?.data?.message);
      }
    }
    return response?.data;
  }
);

//Get user certification request
export const getUserCertificationRequest_USER = createAsyncThunk(
  "getUserCertificationRequest_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getUserCertificationRequest_USER}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      if (response?.status === !404) {
        notifyError(response?.data?.message);
      }
    }
    return response?.data;
  }
);

export const getReportDetailspdfData = createAsyncThunk(
  "getReportDetailspdfData",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.reportDetailsPDF}/${data?.assessmentId}`
    );
    if (response?.status === 200) {
      data?.callBack(response);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
)

export const addUserFeedback = createAsyncThunk(
  "addUserFeedback",
  async ({ data, callBack }) => {
    const response = await APIKit().put(
      `${API_END_POINTS.addUserFeedback}`,
      data
    );

    if (response?.status === 200 || response?.status === 201) {
      callBack?.(response);
    } else {
      notifyError(response?.data?.message);
    }

    return response?.data;
  }
);

export const viewUserFeedback = createAsyncThunk(
  "viewUserFeedback",
  async ({ data, callBack }) => {
    const response = await APIKit().get(
      `${API_END_POINTS.viewUserFeedback}`,
      { params: data }
    );

    if (response?.status === 200 || response?.status === 201) {
      callBack?.(response);
    } else {
      notifyError(response?.data?.message);
    }

    return response?.data;
  }
);

export const saveIndividualAnswer = createAsyncThunk(
  "saveIndividualAnswer",
  async ({ data, callBack }) => {
    const response = await APIKit().post(
      `${API_END_POINTS.saveIndividualAnswer}`,
      data?.data
    );
    if (response?.status === 201 || response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message)
    }
    return response?.data;
  }
);

export const getIndividualAnswer = createAsyncThunk(
  "getIndividualAnswer",
  async (data) => {
    const response = await APIKit().get(
      `${API_END_POINTS.getIndividualAnswer}?assessment_id=${data?.assessment_id}&category_id=${data?.category_id}&sub_category_id=${data?.sub_category_id}&question_id=${data?.question_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const saveIndividualInsight = createAsyncThunk(
  "saveIndividualInsight",
  async ({ data, callBack }) => {
    const response = await APIKit().post(
      `${API_END_POINTS.saveIndividualInsight}`,
      data
    );
    if (response?.status === 201 || response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message)
    }
    return response?.data;
  }
);

export const getIndividualInsight = createAsyncThunk(
  "getIndividualInsight",
  async (data) => {
    const response = await APIKit().get(
      `${API_END_POINTS.getIndividualInsight}?assessment_id=${data?.assessment_id}&category_id=${data?.category_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const userFinalSubmit = createAsyncThunk(
  "userFinalSubmit",
  async ({ data, callBack }) => {
    const response = await APIKit().post(
      `${API_END_POINTS.userFinalSubmit}?assessment_id=${data?.assessment_id}`,
    );
    if (response?.status === 201 || response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message)
    }
    return response?.data;
  }
);

export const getPdfData = createAsyncThunk(
  "getPdfData",
  async (data) => {
    const response = await APIKit().get(
      `${API_END_POINTS.getPdfData}/${data?.reportId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const updatePdfURL = createAsyncThunk(
  "updatePdfURL",
  async (data, callBack) => {
    const response = await APIKit().put(
      `${API_END_POINTS.assessmentPdfUrl}/${data?.reportId}`, data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const userFeedbackModule = createAsyncThunk(
  "userFeedbackModule",
  async ({ data, callBack }) => {
    const response = await APIKit().post(
      `${API_END_POINTS.userFeedbackModule}`,
      data
    );
    if (response?.status === 201 || response?.status === 200) {
      callBack && callBack(response?.data);
    } else {
      notifyError(response?.data?.message)
    }
    return response?.data;
  }
);

export const getUserFeedbackModule = createAsyncThunk(
  "getUserFeedbackModule",
  async (data) => {
    const response = await APIKit().get(
      `${API_END_POINTS.getUserFeedbackModule}?assessmentId=${data?.assessment_id}&categoryId=${data?.category_id}&role=${data?.role}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);




export const multiUpload = createAsyncThunk("multiUpload", async (data) => {
  // Function to sanitize file names
  const sanitizeFileName = (fileName) => {
    const name = fileName.slice(0, fileName.lastIndexOf(".")) || "file";
    const extension = fileName.slice(fileName.lastIndexOf(".") + 1);

    // Normalize Unicode (e.g., 𝐆𝐨𝐣𝐨 → Gojo)
    const normalizedName = name.normalize("NFKD").replace(/[̀-ͯ]/g, "");

    // Remove any non-alphanumeric characters, hyphens, or underscores
    const cleanName = normalizedName.replace(/[^a-zA-Z0-9_-]/g, "");

    // Clean the file extension
    const cleanExtension = extension.replace(/[^a-zA-Z0-9]/g, "");

    return `${cleanName}.${cleanExtension}`;
  };

  // Sanitize files in the FormData
  const sanitizedFormData = new FormData();
  for (let [key, value] of data?.files.entries()) {
    if (value instanceof File) {
      const sanitizedFile = new File(
        [value],
        sanitizeFileName(value.name),
        { type: value.type }
      );
      sanitizedFormData.append(key, sanitizedFile);
    } else {
      sanitizedFormData.append(key, value);
    }
  }

  // API call
  const response = await APIKit(true).post(
    `${API_END_POINTS.multiUpload}`,
    sanitizedFormData
  );

  if (response?.status === 200) {
    data?.callBack(response?.data?.data);
  } else {
    notifyError(response?.data?.message);
  }

  return response?.data;
});


const userSlice = createSlice({
  name: "user",
  initialState: {
    isLoading: false,
    recommendationisLoading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    //Pre assessent category list request
    builder
      .addCase(preAsessmentCategoryListRequest_USER.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        preAsessmentCategoryListRequest_USER.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        preAsessmentCategoryListRequest_USER.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );
    builder
      .addCase(preAssessmentViewAssessment.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        preAssessmentViewAssessment.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        preAssessmentViewAssessment.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Pre assessent sub category list request
    builder
      .addCase(preAsessmentSubCategoryListRequest_USER.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        preAsessmentSubCategoryListRequest_USER.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        preAsessmentSubCategoryListRequest_USER.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Pre assessent question request
    builder
      .addCase(preAsessmentQuestionRequest_USER.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(preAsessmentQuestionRequest_USER.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(preAsessmentQuestionRequest_USER.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Pre assessent options of question request
    builder
      .addCase(preAsessmentOptionsOfQuestionRequest_USER.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        preAsessmentOptionsOfQuestionRequest_USER.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        preAsessmentOptionsOfQuestionRequest_USER.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    builder
      .addCase(getAssessmentJourney.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getAssessmentJourney.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getAssessmentJourney.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get user certification request
    builder
      .addCase(getUserCertificationRequest_USER.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getUserCertificationRequest_USER.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getUserCertificationRequest_USER.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get user past assessment request
    builder
      .addCase(getPastAssessment_USER.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getPastAssessment_USER.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getPastAssessment_USER.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get user get recommendation request
    builder
      .addCase(getRecommendation_USER.pending, (state) => {
        state.recommendationisLoading = "loading";
      })
      .addCase(getRecommendation_USER.fulfilled, (state, action) => {
        state.recommendationisLoading = "succeeded";
      })
      .addCase(getRecommendation_USER.rejected, (state, action) => {
        state.recommendationisLoading = "failed";
      });

    // multi upload
    builder
      .addCase(multiUpload.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(multiUpload.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(multiUpload.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    // Get all getAssessmentSubCategoryDetails_USER
    builder
      .addCase(getAssessmentSubCategoryDetails_USER.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getAssessmentSubCategoryDetails_USER.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getAssessmentSubCategoryDetails_USER.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    // Get all getAssessmentSubCategoryDetails_USER
    builder
      .addCase(getAssessmentReport.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getAssessmentReport.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getAssessmentReport.rejected, (state, action) => {
        state.isLoading = "failed";
      });
  },
});

export default userSlice.reducer;
